import { createTheme } from "@mui/material/styles";

// Create a MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#5B41FF", //Indigo
      light: "#EDF0FF", //Light Indigo
    },
    secondary: {
      main: "#FF7C3A", //Papaya
      light: "#FFF5E5", //Light Papaya
    },
    warning: {
      main: "#5B41FF", //Mid Indigo
    },
    info: {
      main: "#fff",
    },
    error: {
      main: "#333",
    },
    text: {
      secondary: "#AAAAAA",
    },
    background: {
      default: "#F7F8FC",
    },
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 400,
        },
      },
    },
  },
  typography: {
    h1: {
      fontSize: "28px",
      fontWeight: "400",
      fontFamily: "Agrandir",
    },
    h2: {
      fontSize: "24px",
      fontWeight: "600",
      fontFamily: "Agrandir",
    },
    h3: {
      fontSize: "20px",
      fontWeight: "600",
      fontFamily: "Agrandir",
    },
    h4: {
      fontSize: "18px",
      fontWeight: "600",
      fontFamily: "Agrandir",
    },
    h5: {
      fontSize: "16px",
      fontWeight: "600",
      // fontFamily: "Agrandir",
    },
    body1: {
      fontSize: "16px",
      fontWeight: "300",
    },
    body2: {
      fontSize: "14px",
      fontWeight: "300",
    },
    subtitle1: {
      fontSize: "18px",
      fontWeight: "500",
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: "300",
    },
    button: {
      textTransform: "none",
    },
    fontFamily: ["Roboto", "sans-serif"].join(","),
  },
});

export default theme;
